import { Component, Input } from '@angular/core';
import SwiperCore, { FreeMode, Navigation, Pagination } from 'swiper';
import { ExpectedOwnedStrategy } from '../owned-strategy-card/strategy';
import { xlDesktopWidthBreakpoint, desktopWidthBreakpoint } from '../constants';

SwiperCore.use([FreeMode, Pagination, Navigation]);

@Component({
  selector: 'libero-owned-strategy-carousel',
  templateUrl: './owned-strategy-carousel.component.html',
  styleUrls: ['./owned-strategy-carousel.component.scss'],
  standalone: false
})
export class OwnedStrategyCarouselComponent {
  @Input() public ownedStrategies?: ExpectedOwnedStrategy[];

  public get slidesPerView(): number | 'auto' {
    if(!this.ownedStrategies) {
      return 'auto';
    }

    if(window.innerWidth < xlDesktopWidthBreakpoint) {
      return this.ownedStrategies.length > 1 ? 2 : 1;
    }

    return this.ownedStrategies.length > 2 ? 3 : this.ownedStrategies.length;
  }

  public showSimpleSwiper(): boolean {
    if(!this.ownedStrategies) {
      return false;
    }

    if(window.innerWidth > desktopWidthBreakpoint && window.innerWidth < xlDesktopWidthBreakpoint && this.ownedStrategies.length > 2) {
      return false;
    }

    return this.ownedStrategies.length < 4;
  }
}
